<h1 mat-dialog-title>
  <span>{{ "common.modal.filters.title" | translate }}</span>
</h1>
<div mat-dialog-content>
  <form
    [formGroup]="filterFormGroup"
    fxLayout="row"
    aria-describedby="portal group table"
  >
    <!-- Field form field -->
    <mat-form-field>
      <mat-label>{{ "common.modal.filters.field" | translate }}</mat-label>
      <mat-select formControlName="field">
        <mat-option *ngFor="let f of data.fields" [value]="f">
          {{ f.text }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="filterFormGroup.get('field').hasError('required')">{{
        "common.dialog.errors.required" | translate
      }}</mat-error>
    </mat-form-field>
    <!-- Value form field -->
    <ng-container [ngSwitch]="selectedField?.type">
      <ng-container *ngSwitchCase="FieldType.TEXT">
        <mat-form-field fxFlex>
          <mat-label>{{ "common.modal.filters.value" | translate }}</mat-label>
          <input matInput formControlName="value" />
          <mat-error
            *ngIf="filterFormGroup.get('value').hasError('required')"
            >{{ "common.dialog.errors.required" | translate }}</mat-error
          >
        </mat-form-field>
      </ng-container>
      <!--UPPERCASE-->
      <ng-container *ngSwitchCase="FieldType.UPPERCASE">
        <mat-form-field fxFlex>
          <mat-label>{{ "common.modal.filters.value" | translate }}</mat-label>
          <input matInput formControlName="value" oninput="this.value = this.value.toUpperCase()" />
          <mat-error
            *ngIf="filterFormGroup.get('value').hasError('required')"
            >{{ "common.dialog.errors.required" | translate }}</mat-error>
        </mat-form-field>
      </ng-container>
      <!--LOWERCASE_ARRAY-->
      <ng-container *ngSwitchCase="FieldType.LOwERCASE_ARRAY">
        <mat-form-field fxFlex>
          <mat-label>{{ "common.modal.filters.value" | translate }}</mat-label>
          <mat-chip-list #chipList>
            <mat-chip
              *ngFor="let value of values"
              [selectable]="selectable"
              [removable]="removable"
              (removed)="remove(value)">
              {{ value }}
              <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip>
            <input
              #valueInput
              formControlName="value"
              [matChipInputAddOnBlur]="addOnBlur"
              (matChipInputTokenEnd)="add($any($event))"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputFor]="chipList"
              [matAutocomplete]="filterAutocomplete"
            />
          </mat-chip-list>
          <mat-autocomplete
            (optionSelected)="selected($any($event))"
            #filterAutocomplete="matAutocomplete"
            [displayWith]="displayFn()"
          >
            <mat-option
              *ngFor="let option of filteredOptions | async"
              [value]="option.id"
            >
              {{ option.description }}
            </mat-option>
          </mat-autocomplete>

          <mat-error
            *ngIf="filterFormGroup.get('value').hasError('required')"
            >{{ "common.dialog.errors.required" | translate }}</mat-error
          >
        </mat-form-field>
      </ng-container>
      <!--UPPERCASE_ARRAY-->
      <ng-container *ngSwitchCase="FieldType.UPPERCASE_ARRAY">
        <mat-form-field fxFlex>
          <mat-label>{{ "common.modal.filters.value" | translate }}</mat-label>
          <mat-chip-list #chipList>
            <mat-chip
              *ngFor="let value of values"
              [selectable]="selectable"
              [removable]="removable"
              (removed)="remove(value)">
              {{ value }}
              <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip>
            <input
              #valueInput
              formControlName="value"
              [matChipInputAddOnBlur]="addOnBlur"
              (matChipInputTokenEnd)="add($any($event))"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputFor]="chipList"
              [matAutocomplete]="filterAutocomplete"
              oninput="this.value = this.value.toUpperCase()"
            />
          </mat-chip-list>
          <mat-autocomplete
            (optionSelected)="selected($any($event))"
            #filterAutocomplete="matAutocomplete"
            [displayWith]="displayFn()"
          >
            <mat-option
              *ngFor="let option of filteredOptions | async"
              [value]="option.id"
            >
              {{ option.description }}
            </mat-option>
          </mat-autocomplete>

          <mat-error
            *ngIf="filterFormGroup.get('value').hasError('required')"
            >{{ "common.dialog.errors.required" | translate }}</mat-error
          >
        </mat-form-field>
      </ng-container>
      <!--GRAFANA_AUTOCOMPLETE-->
      <ng-container *ngSwitchCase="FieldType.GRAFANA_AUTOCOMPLETE">
        <mat-form-field fxFlex>
          <mat-label>{{ "common.modal.filters.value" | translate }}</mat-label>
          <input
            matInput
            formControlName="value"
            [matAutocomplete]="filterAutocomplete"
          />

          <mat-autocomplete
            #filterAutocomplete="matAutocomplete"
            [displayWith]="displayFn()"
          >
            <mat-option
              *ngFor="let option of filteredOptions | async"
              [value]="option.description"
            >
              {{ option.description }}
            </mat-option>
          </mat-autocomplete>

          <mat-error
            *ngIf="filterFormGroup.get('value').hasError('required')"
            >{{ "common.dialog.errors.required" | translate }}</mat-error
          >
        </mat-form-field>
      </ng-container>
      <!--VEHICLE_STATUS-->
      <ng-container *ngSwitchCase="FieldType.VEHICLE_STATUS">
        <mat-form-field fxFlex>
          <mat-label>{{ "common.modal.filters.value" | translate }}</mat-label>
          <mat-select formControlName="value" multiple [(value)]="value">
            <mat-option value="Attivo">Attivo</mat-option>
            <mat-option value="Inattivo">Inattivo</mat-option> 
            <mat-option value="Manutenzione">Manutenzione</mat-option>
          </mat-select>
          <mat-error *ngIf="filterFormGroup.get('value').hasError('required')">{{ "common.dialog.errors.required" | translate }}</mat-error>
        </mat-form-field>
      </ng-container>
       <!--DOCTYPE-->
       <ng-container *ngSwitchCase="FieldType.DOCTYPE">
        <mat-form-field fxFlex>
          <mat-label>{{ "common.modal.filters.value" | translate }}</mat-label>
          <mat-select formControlName="value" [(value)]="value">
            <mat-option value="1">Documento di Carico</mat-option>
            <mat-option value="2">Documento di Scarico</mat-option> 
          </mat-select>
          <mat-error *ngIf="filterFormGroup.get('value').hasError('required')">{{ "common.dialog.errors.required" | translate }}</mat-error>
        </mat-form-field>
      </ng-container>
      <!--STATUS-->
      <ng-container *ngSwitchCase="FieldType.STATUS">
        <mat-form-field fxFlex>
          <mat-label>{{ "common.modal.filters.value" | translate }}</mat-label>
          <mat-select formControlName="value" multiple [(value)]="value">
            <mat-option value="In attesa">In attesa</mat-option>
            <mat-option value="Preso in carico">Preso in carico</mat-option> 
            <mat-option value="Completato">Completato</mat-option>
            <mat-option value="Completato Parzialmente">Completato Parzialmente</mat-option>
            <mat-option value="Sospeso">Sospeso</mat-option>
            <mat-option value="Ignorato">Ignorato</mat-option>
            <mat-option value="Chiuso da sistema">Chiuso da sistema</mat-option>
          </mat-select>
          <mat-error *ngIf="filterFormGroup.get('value').hasError('required')">{{ "common.dialog.errors.required" | translate }}</mat-error>
        </mat-form-field>
      </ng-container>
      <!--CONTRACT_TYPE-->
      <ng-container *ngSwitchCase="FieldType.CONTRACT_TYPE">
        <mat-form-field fxFlex>
          <mat-label>{{ "common.modal.filters.value" | translate }}</mat-label>
          <mat-select formControlName="value" multiple [(value)]="value">
            <mat-option value="0">DOMESTICA</mat-option>
            <mat-option value="1">NON DOMESTICA</mat-option> 
          </mat-select>
          <mat-error *ngIf="filterFormGroup.get('value').hasError('required')">{{ "common.dialog.errors.required" | translate }}</mat-error>
        </mat-form-field>
      </ng-container>
      <!--BOOLEAN-->
      <ng-container *ngSwitchCase="FieldType.BOOLEAN">
        <mat-form-field fxFlex>
          <mat-label>{{ "common.modal.filters.value" | translate }}</mat-label>
          <mat-select formControlName="value">
            <mat-option value="True">
              <mat-icon>
                check
              </mat-icon>
            </mat-option>
            <mat-option value="False">
              <mat-icon>
                clear
              </mat-icon>
            </mat-option>
          </mat-select>
          <mat-error *ngIf="filterFormGroup.get('value').hasError('required')">{{ "common.dialog.errors.required" | translate }}</mat-error>
        </mat-form-field>
      </ng-container>
      <!--CLIENT_SIDE_BOOLEAN-->
      <ng-container *ngSwitchCase="FieldType.CLIENT_SIDE_BOOLEAN">
        <mat-form-field fxFlex>
          <mat-label>{{ "common.modal.filters.value" | translate }}</mat-label>
          <mat-select formControlName="value">
            <mat-option value="1">
              <p style="color:#2ec913">⬤ Connesso</p>
            </mat-option>
            <mat-option value="2">
              <p style="color:orange">⬤ Non Conesso da 48H</p>
            </mat-option>
            <mat-option value="3">
              <p style="color:red">⬤ Non Conesso da più di 48H</p>
            </mat-option>
            <mat-option value="4">
              <p style="color:grey">⬤ Non MQuadro</p>
            </mat-option>
          </mat-select>
          <mat-error *ngIf="filterFormGroup.get('value').hasError('required')">{{ "common.dialog.errors.required" | translate }}</mat-error>
        </mat-form-field>
      </ng-container>
      <!--AUTOCOMPLETE-->
      <ng-container *ngSwitchCase="FieldType.AUTOCOMPLETE">
        <mat-form-field fxFlex>
          <mat-label>{{ "common.modal.filters.value" | translate }}</mat-label>
          <input
            matInput
            formControlName="value"
            [matAutocomplete]="filterAutocomplete"
          />

          <mat-autocomplete
            #filterAutocomplete="matAutocomplete"
            [displayWith]="displayFn()"
          >
            <mat-option
              *ngFor="let option of filteredOptions | async"
              [value]="option.id"
            >
              {{ option.description }}
            </mat-option>
          </mat-autocomplete>

          <mat-error
            *ngIf="filterFormGroup.get('value').hasError('required')"
            >{{ "common.dialog.errors.required" | translate }}</mat-error
          >
        </mat-form-field>
      </ng-container>
      <!--AUTOCOMPLETE_UPPER-->
      <ng-container *ngSwitchCase="FieldType.AUTOCOMPLETE_UPPER">
        <mat-form-field fxFlex>
          <mat-label>{{ "common.modal.filters.value" | translate }}</mat-label>
          <input
            matInput
            formControlName="value"
            [matAutocomplete]="filterAutocomplete"
            oninput="this.value = this.value.toUpperCase()"
          />

          <mat-autocomplete
            #filterAutocomplete="matAutocomplete"
            [displayWith]="displayFn()"
          >
            <mat-option
              *ngFor="let option of filteredOptions | async"
              [value]="option.id"
            >
              {{ option.description }}
            </mat-option>
          </mat-autocomplete>

          <mat-error
            *ngIf="filterFormGroup.get('value').hasError('required')"
            >{{ "common.dialog.errors.required" | translate }}</mat-error
          >
        </mat-form-field>
      </ng-container>
      <!--AUTOCOMPLETE_DATE-->
      <ng-container *ngSwitchCase="FieldType.AUTOCOMPLETE_DATE">
        <mat-form-field fxFlex>
          <mat-label>GG-MM-AAAA HH:MM:SS</mat-label>
          <input
            matInput
            formControlName="value"
            [matAutocomplete]="filterAutocomplete"
          />

          <mat-autocomplete
            #filterAutocomplete="matAutocomplete"
            [displayWith]="displayFn()"
          >
            <mat-option
              *ngFor="let option of filteredOptions | async"
              [value]="option.id"
            >
              {{ option.description }}
            </mat-option>
          </mat-autocomplete>

          <mat-error
            *ngIf="filterFormGroup.get('value').hasError('required')"
            >{{ "common.dialog.errors.required" | translate }}</mat-error
          >
        </mat-form-field>
      </ng-container>
      <!--CDRI SUB CATEGORY-->
      <ng-container *ngIf="this.filterFormGroup.value.value && check_if_json()">
        <mat-form-field fxFlex>
          <mat-label >{{ "common.modal.filters.value" | translate }}</mat-label>
          <mat-select [(value)]="type" multiple formControlName="type">
            <mat-option *ngFor="let subcategory of get_subcategory(this.filterFormGroup.value.value)" [value]="subcategory.cod">
              {{ subcategory.tipologia }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>
      <!--DATETIME-->
      <ng-container *ngSwitchCase="FieldType.DATETIME">
        <mat-form-field fxFlex>
          <mat-label>{{ "common.modal.filters.value" | translate }}</mat-label>
          <input matInput type="date" formControlName="value">
        </mat-form-field>
      </ng-container>
      <!--DATERANGE-->
      <ng-container *ngSwitchCase="FieldType.DATERANGE">
        <mat-form-field appearance="fill">
          <mat-label>{{ "common.modal.filters.value" | translate }}</mat-label>
          <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
            <input matStartDate formControlName="start" placeholder="Inizio" [value]="start | date: 'yyyy-MM-dd'">
            <input matEndDate formControlName="end" placeholder="Fine" [value]="end | date: 'yyyy-MM-dd'">
          </mat-date-range-input>
          <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
      </ng-container>
      <!--GRAFANA_DATERANGE-->
      <ng-container *ngSwitchCase="FieldType.GRAFANA_DATERANGE">
        <mat-form-field appearance="fill">
          <mat-label>{{ "common.modal.filters.value" | translate }}</mat-label>
          <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
            <input matStartDate formControlName="start" placeholder="Inizio" [value]="start | date: 'yyyy-MM-dd'">
            <input matEndDate formControlName="end" placeholder="Fine" [value]="end | date: 'yyyy-MM-dd'">
          </mat-date-range-input>
          <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
      </ng-container>
      <!--DEFAULT-->
      <ng-container *ngSwitchDefault>
        <mat-form-field fxFlex>
          <mat-label>{{ "common.modal.filters.value" | translate }}</mat-label>
          <input matInput disabled />
          <mat-error
            *ngIf="filterFormGroup.get('value').hasError('required')"
            >{{ "common.dialog.errors.required" | translate }}</mat-error
          >
        </mat-form-field>
      </ng-container>
    </ng-container>
  </form>
</div>
<div mat-dialog-actions fxLayoutAlign="center center">
  <button mat-button mat-dialog-close>
    {{ "common.dialog.cancel" | translate }}
  </button>
  <button mat-button cdkFocusInitial color="primary" (click)="addFilter()" >
    {{ "common.dialog.add" | translate }}
  </button>
</div>
